<template>
    <top-bar-secondary>
        <b-navbar-nav>
            <!-- <b-nav-item v-if="isSaving" disabled>
                <i class="cus-hourglass"></i>Saving...
            </b-nav-item>
            <template v-else-if="isNewMode">
                <b-nav-item @click="save(false)">
                    <i class="cus-disk"></i>Save + Done
                </b-nav-item>
                <b-nav-item @click="save(true)">
                    <i class="cus-disk"></i>Save + Add New
                </b-nav-item>
            </template>
            <b-nav-item v-else-if="isEditMode" @click="save()">
                <i class="cus-disk"></i>Save
            </b-nav-item>

            <b-nav-item
                v-if="(isEditMode || isNewMode) && !isSaving"
                @click="cancel()"
            >
                <i class="cus-cancel"></i>Cancel
            </b-nav-item> -->
        </b-navbar-nav>
    </top-bar-secondary>
</template>

<script>
import { isNil } from "lodash";
import TopBarSecondary from "@/module/layout/top-bar-secondary.vue";

const MODE_EDIT = "EDIT";
const MODE_NEW = "NEW";

export default {
    components: {
        TopBarSecondary
    },
    props: {
        profile: {
            default() {},
            type: Object
        }
    },
    computed: {
        isCanEdit() {
            return this._hasAccess("report.scheduled_reports.edit");
        },
        isEditMode() {
            return this.profile.mode === MODE_EDIT;
        },
        isNewMode() {
            return this.profile.mode === MODE_NEW;
        },
        isSaving() {
            return this.profile?.isSaving || false;
        }
    },
    methods: {
        save(addNew) {
            this.$emit("save", { addNew });
        },
        cancel() {
            this.$emit("cancel");
        }
    }
};
</script>
